export class InternalMessage {
    action: string;
    parameters: any;    
  }
  